module.exports = __webpack_public_path__ + "3edc895524b864cc0fb40da598a8559a.svg";